'use client'

import { useState } from "react"
import { Category, CommerceProduct } from "@/app/types"
import { ProductHeader } from "@/components/molecules/ProductHeader/product-header"
import { VariantsSection } from "@/components/organisms/Product/variants"
import { mapCurrencyToSign } from '@/utils/index'

type VariantSelectorIslandProps = {
  product: CommerceProduct
  translations: Record<string, any>
}

export function VariantSelectorIsland({ product, translations }: VariantSelectorIslandProps) {
  const [selectedVariant, setSelectedVariant] = useState(0)
  const currentVariant = product.variants?.[selectedVariant] || null
  const price = currentVariant?.price ?? product.price

  return (
    <div className="space-y-6">
      {/* Product Header */}
      <div className="md:block hidden">
        <ProductHeader
          productId={product.id}
          categories={product.categories as Category[]}
          title={product.name}
          price={price}
          currency={mapCurrencyToSign("USD")}
          condition={product.condition}
          updatedAt={product.updatedAt}
          averageRating={product.averageRating}
          reviewsCount={product.reviewCount}
          translations={translations}
        />
      </div>

      {/* Variants Section */}
      {product.variants && product.variants.length > 0 && (
        <VariantsSection
          variants={product.variants}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          currentVariant={currentVariant}
        />
      )}
    </div>
  )
}
